import axios from 'axios';
import { BehaviorSubject } from 'rxjs';
import VueJwtDecode from 'vue-jwt-decode'
import MonitoramentoVisitaService from "../nfse/monitoramento.visita.service";
import UAParser from 'ua-parser-js';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/usuario';
const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));


const parser = new UAParser();
const browserInfo = parser.getBrowser();
const osInfo = parser.getOS();
axios.interceptors.request.use((config) => {
    config.headers['X-Client-Browser'] = `${browserInfo.name} ${browserInfo.version}`;
    config.headers['X-Client-OS'] = `${osInfo.name} ${osInfo.version}`;
    return config;
});

class LoginService {
    constructor() {
    }

    get currentUserValue() {
        return currentUserSubject.value;
    }
    get currentUser() {
        return currentUserSubject.asObservable();
    }

    isTokenExpired() {
        if (this.currentUserValue && this.currentUserValue.token) {
            const token = this.currentUserValue.token;
            try {
                const date = new Date(0);
                const decoded = VueJwtDecode.decode(token);
                date.setUTCSeconds(decoded.exp);
                return new Date().valueOf() > date.valueOf();
            } catch (err) {
                return false;
            }
        }
        return false;
    }

    updateStorage(data) {
        localStorage.removeItem('currentUser');
        currentUserSubject.next(null);
        localStorage.setItem('currentUser', JSON.stringify(data));
        currentUserSubject.next(data);
    }

    async login(login, idCliente) {
        try {
            const dadosUsuario = await this.capturarDadosUsuario();
            const result = await axios.post(
                API_URL + '/login?idCliente=' + idCliente,
                JSON.stringify({ ...login, usuarioInfo: dadosUsuario }),
                {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'X-Client-Browser': dadosUsuario.navegador,
                        'X-Client-OS': dadosUsuario.sistemaOperacional,
                        'X-Client-IP': dadosUsuario.ip
                    }
                }
            ).then(response => {
                localStorage.setItem('currentUser', JSON.stringify(response.data));
                currentUserSubject.next(response.data);
                return response.data;
            });

            await MonitoramentoVisitaService.save({ pagina: "acessoMonitoramento" });
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async capturarDadosUsuario() {
        try {
            const parser = new UAParser();
            const browserInfo = parser.getBrowser();
            const osInfo = parser.getOS();

            const response = await axios.get("https://api.ipify.org?format=json", {
                timeout: 3000 // Timeout de 3 segundos
            });
            const ip = response.data.ip;

            return {
                ip: ip,
                navegador: `${browserInfo.name} ${browserInfo.version}`,
                sistemaOperacional: `${osInfo.name} ${osInfo.version}`
            };
        } catch (error) {
            console.error('Erro ao capturar dados do usuário:', error);
            return {
                ip: "0.0.0.0",
                navegador: "Desconhecido",
                sistemaOperacional: "Desconhecido"
            };
        }
    }

    loginAuth(auth) {
        return axios.post(API_URL + '/loginAuth?auth=' + auth, null,
            { headers: { 'Content-Type': 'application/json; charset=UTF-8' } }).then(
                response => {
                    localStorage.setItem('currentUser', JSON.stringify(response.data));
                    currentUserSubject.next(response.data);
                }
            );
    }

    recuperarSenha(login, idCliente) {
        return axios.post(API_URL + '/recuperarSenha?login=' + login + '&idCliente=' + idCliente, null);
    }

    buscarUsuarioPorChave(chave) {
        return axios.post(API_URL + '/buscarUsuarioPorChave?chave=' + chave, null);
    }

    novaSenha(recuperaSenha) {
        return axios.post(API_URL + '/novaSenha', JSON.stringify(recuperaSenha),
            { headers: { 'Content-Type': 'application/json; charset=UTF-8' } });
    }


    logOut() {
        if (this.currentUserValue && this.currentUserValue.token) {
            MonitoramentoVisitaService.registerLogout();
        }

        localStorage.removeItem('currentUser');
        localStorage.removeItem('displayAvisoEntradaSistema');
        currentUserSubject.next(null);
        return axios.post(API_URL + '/login/logout/');
    }

    findAllAvisos(idCliente) {
        return axios.get(API_URL + '/allAvisos?idCliente=' + idCliente);
    }

}

export default new LoginService();